import script from "./ModalOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./ModalOverlay.vue?vue&type=style&index=0&id=65d76b6b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d76b6b"]])

export default __exports__